import React, { Component } from 'react';
import LocationChecker from '../components/LocationChecker';
const HomePage = () => {
  return <div className="w-full" data-id="element-171">
      {/* Hero Section */}
      <section className="relative bg-teal-50 min-h-[calc(100vh-73px)] flex items-center" data-id="element-172">
        <div className="container mx-auto px-4 md:px-6" data-id="element-173">
          <div className="flex flex-col md:flex-row items-center" data-id="element-174">
            <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-175">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-176">
                Beauty treatments at your doorstep
              </h1>
              <p className="text-lg text-gray-600 mb-8" data-id="element-177">
                Professional beauty services delivered to your home, office, or
                hotel
              </p>

              {/* Location Checker Component */}
              <LocationChecker data-id="element-178" />
            </div>
            <div className="md:w-1/2" data-id="element-179">
              <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="At-home beauty treatment" className="rounded-lg shadow-lg w-full h-auto" data-id="element-180" />
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default HomePage;